
import React from "react";
import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { SmoothScrollLink } from "./SmoothScrollLink";

export const MobileNav = () => {
  return (
    <Sheet>
      <SheetTrigger asChild className="md:hidden">
        <Button variant="ghost" size="icon">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-[300px] sm:w-[400px]">
        <nav className="flex flex-col gap-4">
          <SmoothScrollLink to="#home" className="text-lg font-medium hover:text-primary">
            Chat
          </SmoothScrollLink>
          <SmoothScrollLink to="#inspirational-ai" className="text-lg font-medium hover:text-primary">
            Inspirational AI
          </SmoothScrollLink>
          <SmoothScrollLink to="#self-directed-ai" className="text-lg font-medium hover:text-primary">
            Self-directed AI
          </SmoothScrollLink>
          <SmoothScrollLink to="#system-status" className="text-lg font-medium hover:text-primary">
            System Status
          </SmoothScrollLink>
          <SmoothScrollLink to="#about" className="text-lg font-medium hover:text-primary">
            About
          </SmoothScrollLink>
        </nav>
      </SheetContent>
    </Sheet>
  );
};
